// Theme system matching legacy aQRate Portal colors
const tintColorLight = '#59caee';
const tintColorDark = '#59caee';

export const Colors = {
  light: {
    text: '#222939',
    background: '#f8fafc',
    backgroundSecondary: '#ffffff',
    tint: tintColorLight,
    primary: '#232562',
    icon: '#47556b',
    tabIconDefault: '#47556b',
    tabIconSelected: tintColorLight,
    border: '#e2e8f0',
    success: '#10bb10',
    warning: '#ffc107',
    danger: '#dc3545',
    info: '#59caee',
    muted: '#47556b',
    sidebar: {
      background: '#232562',
      text: '#d0d5e8',
      textActive: '#ffffff',
      hover: '#2d3070',
      border: '#2d3070'
    }
  },
  dark: {
    text: '#ECEDEE',
    background: '#0f1229',
    backgroundSecondary: '#161a42',
    tint: tintColorDark,
    primary: '#59caee',
    icon: '#9BA1A6',
    tabIconDefault: '#9BA1A6',
    tabIconSelected: tintColorDark,
    border: '#232562',
    success: '#10bb10',
    warning: '#ffc107',
    danger: '#dc3545',
    info: '#59caee',
    muted: '#60739f',
    sidebar: {
      background: '#0d1035',
      text: '#a0a8cc',
      textActive: '#ffffff',
      hover: '#1a1f52',
      border: '#232562'
    }
  },
};

export const Typography = {
  sizes: {
    small: '14px',
    default: '16px',
    medium: '18px',
    large: '20px',
    title: '32px',
    subtitle: '20px'
  },
  weights: {
    normal: '400',
    semiBold: '600',
    bold: '700'
  },
  lineHeights: {
    tight: '20px',
    default: '24px',
    relaxed: '30px',
    title: '32px'
  }
};

export const Spacing = {
  xs: '4px',
  sm: '8px',
  md: '16px',
  lg: '24px',
  xl: '32px',
  xxl: '48px'
};

export const BorderRadius = {
  sm: '4px',
  md: '8px',
  lg: '12px',
  xl: '16px',
  round: '50%'
};

export const Shadows = {
  sm: '0 2px 4px rgba(35, 37, 98, 0.08)',
  md: '0 4px 8px rgba(35, 37, 98, 0.12)',
  lg: '0 8px 24px rgba(35, 37, 98, 0.15)'
};

export const Transitions = {
  fast: '0.1s ease',
  default: '0.2s ease',
  slow: '0.3s cubic-bezier(0.4, 0, 0.2, 1)',
};